<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    class="video-close-btn"
    @click.prevent="handleClose"
  >
    <g transform="translate(-1148 -291)">
      <circle
        cx="28"
        cy="28"
        r="28"
        transform="translate(1148 291)"
        style="fill: rgb(255, 255, 255); opacity: 0.16"
      ></circle>
      <path
        d="m30.857 41.946 5.7-5.7a.747.747 0 0 0 0-1.05l-.031-.031a.746.746 0 0 0-1.05 0l-5.7 5.71-5.7-5.71a.746.746 0 0 0-1.05 0l-.026.029a.733.733 0 0 0 0 1.05l5.7 5.7-5.7 5.7a.747.747 0 0 0 0 1.05l.031.031a.746.746 0 0 0 1.05 0l5.7-5.7 5.7 5.7a.746.746 0 0 0 1.05 0l.031-.031a.747.747 0 0 0 0-1.05Z"
        transform="translate(1146.227 277.053)"
        style="fill: rgb(255, 255, 255)"
      ></path>
    </g>
  </svg>
</template>
<script>
export default {
  name: 'clos-icon',
  props: {
    handleClose: {
      type: Function,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped>
.video-close-btn {
  position: absolute;
  top: 30px;
  left: 30px;
  z-index: 2;
  padding: 10px;
  z-index: 3;
  width: 76px;
  height: 76px;
  &:hover {
    cursor: pointer;
  }
}

@media (min-width: 1024px) {
  .video-close-btn {
    top: 10px;
    left: 10px;
  }
}

@media (max-width: 768px) {
  .video-close-btn {
    display: none;
  }
}
</style>
